import React from 'react';
import '../styling/score.css';
import { Link } from 'react-router-dom';

export default function Score() {
  return (
    <>
      <div className='score'>
        <div className="scorebox">
          <h2 className="points">You got {localStorage.getItem(`${localStorage.getItem('oponent_userid')}`)} points!</h2>
          <div className="reverse">Now it's your turn. Create a quiz about yourself and send it to your friends!</div>
          <div className="createturn stbtn"><Link className='createyourquiz' to='/' >Create Quiz</Link></div>
        </div>
      </div>
    </>
  )
}
